import { render, staticRenderFns } from "./ReBranchTree.vue?vue&type=template&id=07367cb6"
import script from "./ReBranchTree.vue?vue&type=script&lang=js"
export * from "./ReBranchTree.vue?vue&type=script&lang=js"
import style0 from "./ReBranchTree.vue?vue&type=style&index=0&id=07367cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports